export default __webpack_public_path__ + "static/andre-merkevarer-7082b271de3f40f223cb82cc9f890542.png";